/** ***********
*
* <sort.pipe.ts v1.0>
*
* Copyright (c) 2023 AIRBUS OPERATIONS
*
* Contributors:
*  GARY Adrien (NG635E8) [adrien.gary.external@airbus.com]
*
* All rights reserved.
**************/

import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'sort',
    standalone: false
})
export class SortPipe implements PipeTransform {

    constructor(
        private _translate: TranslateService,
    ) { }

    /**
     * Sort a list of values (either string / number / Date / Objects)
     * @param items The items to sort
     * @param descending Should the items be sorted by descending order
     * @param property The property on which the list of objects must be sorted
     * @param options Options - see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Collator/Collator#options
     */
    transform<T>(items: T[], descending = false, property?: string, options?: Intl.CollatorOptions): T[] {
        items?.sort(
            (a, b) => {
                let sortResult = 0;
                if (typeof a !== 'object' && typeof b !== 'object') {
                    sortResult = a.toString().localeCompare(b.toString(), this._translate.currentLang, options);
                } else if (a instanceof Date && b instanceof Date) {
                    sortResult = a.getTime() - b.getTime();
                } else if (
                    Object.prototype.hasOwnProperty.call((a as Record<string, any>), property) &&
                    Object.prototype.hasOwnProperty.call((b as Record<string, any>), property)
                ) {
                    sortResult = a[property].toString().localeCompare(b[property].toString(), this._translate.currentLang, options);
                }
                return (descending ? -1 : 1) * sortResult;
            }
        );
        return items;
    }

}
